import cn from 'classnames';

import { QuestionInterface } from 'interfaces';
import { getClientOptions } from 'scripts/clients/index'
import { useClientContext, useTranslationContext } from 'hooks';

import CounterButton from 'shared/CounterButton';
import IconAvatar from 'shared/IconAvatar';

import classes from './QuestionsItem.module.scss';

export default function QuestionsItem(props: {
  question: QuestionInterface;
  askButtonColor: string;
  onVoteClick?: (q: QuestionInterface) => void;
  classId: string;
}) {
  const { question, askButtonColor, onVoteClick = (q: QuestionInterface) => { }, classId } = props;
  const { client } = useClientContext();
  const { t, language } = useTranslationContext();

  const showCategoryName = getClientOptions(client)?.questionsList?.showCategoryName || false;

  const getQuestionTranslation = (question: QuestionInterface) => {
    if (language !== question.originalLanguage && question.translations && question.translations[language])
      return question.translations[language];
    return question.text;
  }

  return (
    <div className={cn(classes.QuestionsItem, 'QuestionsItem')}>
      <div className={cn(classes.meta, 'meta')}>
        <div className={cn(classes.user, 'user')}>
          <IconAvatar categoryIcon={question.category} />

          <div className={cn(classes.name, 'name')}>
            {question.user.firstName}

            {showCategoryName && <small>. {t("asked in")}</small>}

            {showCategoryName && <div className={classes.categoryName}>{question.category}</div>}
          </div>
        </div>

        <CounterButton
          buttonCount={question.votes}
          buttonText={question.asked ? "Upvoted" : "+Upvote"}
          isButtonActive={question.asked}
          askButtonColor={askButtonColor}
          handleClick={() => {onVoteClick(question)}}
          classId={classId}
          hasLikedVideo={false}
        />
      </div>
      <div className={classes.questionText}>{getQuestionTranslation(question)}</div>
    </div>
  );
}
